(function() {
  $(document).ready(function() {
    'use strict';
    var nav_items;
    nav_items = $('.navbar ul.navbar-nav.-right li');
  });

}).call(this);
